import { segment, identify, track } from '@mc/track-event'
import { paths } from '@mc/paths'

import request, { isSuccessful, params } from './authApiService'
import {
  setGoogleOneTapQuizSource,
  getGoogleOneTapSignupClicked,
} from '../experiments/pen-3951_v2_google_email_capture/hooks/googleOneTapQuizEntry'

const PROVIDER = 'identity'

const getUrlParameter = (param) => {
  const name = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`)
  const results = regex.exec(window.location.search)

  if (results === null) {
    return ''
  }

  return decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const signIn = ({
  email,
  password,
  nextPage = getUrlParameter('next_page'),
}) =>
  request(
    '/auth/identity/callback',
    params({
      next_page: nextPage,
      auth_key: email,
      password,
      provider: PROVIDER,
    }),
  ).then((res) => {
    if (isSuccessful(res)) {
      identify(res.userId, {
        email: res.email,
        name: res.userName,
      })

      track(segment.EventTypes.SIGNED_IN, {
        location: 'modal',
      })

      return res
    }

    return Promise.reject(new Error('Your email or password are incorrect'))
  })

export const signUp = ({
  email,
  password,
  gdprOptIn = true,
  nextPage = getUrlParameter('next_page'),
}) =>
  request(
    '/auth/identity/register',
    params({
      next_page: nextPage,
      email,
      password,
      password_confirmation: password,
      provider: PROVIDER,
      gdpr_opt_in: gdprOptIn,
    }),
  ).then((res) => {
    identify(res.userId, {
      email: res.email,
    })

    track(segment.EventTypes.ACCOUNT_CREATED, {
      email: res.email,
      userId: res.userId,
      location: 'sign up modal',
    })

    track(segment.EventTypes.SIGNED_UP, {
      auth: 'email',
    })

    return res
  })

export const resetPassword = (data) =>
  request('/api/v1/passwords', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

/* eslint-disable camelcase */
export const resetPasswordUpdate = ({
  password,
  password_confirmation,
  token,
}) =>
  request(`/api/v1/passwords/${token}`, {
    method: 'PUT',
    body: JSON.stringify({ password, password_confirmation }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
/* eslint-enable camelcase */

export const activateEnterpriseAccount = (data, id) =>
  request(`/enterprise_seat_tokens/${id}/activate`, params(data))

export const confirmPassword = (data) =>
  request('/user_sessions/create', params({ auth_hash: JSON.stringify(data) }))

export const redirect = (res, onLogIn) => {
  if (res.redirectTo && res.redirectTo !== window.location.href) {
    // redirect when a next_page param is present
    window.location = res.redirectTo

    // pen-3951_v2
    if (
      res.redirectTo.includes(paths.classRecommendations) &&
      getGoogleOneTapSignupClicked()
    ) {
      setGoogleOneTapQuizSource({ source: 'create_account_modal' })
    }
  } else if (typeof onLogIn === 'function') {
    // custom redirect callback
    onLogIn()
  } else {
    window.location.reload()
  }
}
